export default "__VITE_ASSET__BJUmy9QU__"